import React, { useEffect, useRef, useState } from 'react';
import '../CSS/Home.css';
import Header from '../Components/Header';
import Contactbar from '../Components/ContactBar';
import flower from '../assets/Untitled_design-removebg-preview.png.webp';
import wedding1 from '../assets/LIBRA EVENTS/WhatsApp Image 2024-01-26 at 7.51.18 PM (6).jpeg';
import wedding2 from '../assets/LIBRA EVENTS/WhatsApp Image 2024-01-29 at 10.41.31 AM.jpeg';
import wedding3 from '../assets/LIBRA EVENTS/KSH_0083.jpg';
import wedding4 from '../assets/LIBRA EVENTS/KSH_2562.jpg';
import wedding5 from '../assets/LIBRA EVENTS/KSH_7690.jpg';
import wedding6 from '../assets/LIBRA EVENTS/_DSC9636.jpg';
// import wedding2 from '../assets/wedding.jpg';
// import wedding3 from '../assets/wedding.jpg';
// import wedding4 from '../assets/wedding.jpg';
// import wedding5 from '../assets/wedding.jpg';
// import wedding6 from '../assets/wedding.jpg';
import Footer from '../Components/Footer';

// import wedding1 from '../assets/wedding1.jpg';
// import wedding2 from '../assets/wedding2.jpg';
// import wedding3 from '../assets/wedding3.jpg';
// import wedding4 from '../assets/wedding4.jpg';
// import wedding5 from '../assets/wedding5.jpg';

import banquet1 from '../assets/LIBRA EVENTS/WhatsApp Image 2023-12-24 at 7.13.52 PM (14).jpeg';
import banquet2 from '../assets/jyoti2.jpg';
import banquet3 from '../assets/LIBRA EVENTS/_DSC9636.jpg';
import banquet4 from '../assets/LIBRA EVENTS/KSH_3271.jpg';
import { FaHandshake, FaMapMarkerAlt, FaPaintBrush, FaBirthdayCake, FaComments, FaLightbulb } from 'react-icons/fa';
// import Footer from '../Components/Footer';

const banquetImages = [banquet1, banquet2, banquet3,banquet4];

const loopImages = [
  { src: banquet1, name: 'Eva Banquet' },
  { src: banquet2, name: 'Libra Banquet' },
  { src: banquet3, name: 'KB Patel Party Plot' },
];


function Home() {
  const titleRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  // const loopImages = [...banquetImages, ...banquetImages];

  const sliderRef = useRef(null);
  const scrollNext = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: 520, // Adjust based on card width + margin
        behavior: 'smooth',
      });
    }
  };

  const scrollPrev = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({
        left: -520,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // animate only once
        }
      },
      { threshold: 0.5 }
    );

    if (titleRef.current) {
      observer.observe(titleRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const features = [
    { icon: <FaHandshake />, title: 'Friendly Team', desc: 'More than 200 members' },
    { icon: <FaMapMarkerAlt />, title: 'Perfact Venues', desc: 'Indoor & Outdoor' },
    { icon: <FaPaintBrush />, title: 'Unique Theme Decore', desc: 'We thinking out of the box' },
    { icon: <FaBirthdayCake />, title: 'Unforgettable Time', desc: 'We make you perfect event' },
    { icon: <FaComments />, title: 'Quick Support', desc: 'Instant channels' },
    { icon: <FaLightbulb />, title: 'Briliant Idea', desc: 'We have million idea' }
  ];

  const testimonials = [
{
  name: 'Vallav Shah',
  text: 'We hired Libra Events & Decorators for a family wedding and the experience was truly wonderful. The decoration, theme styling, and attention to detail were beyond our expectations. Their team was polite, well-coordinated, and made the entire event look grand.',
  src: banquet4,
},
{
  name: 'Pratik Patel',
  text: 'Libra Events did an excellent job for our wedding event. From stage décor to entrance setup, everything was beautifully executed. The team was professional, supportive, and made sure every detail matched our vision. Highly recommended!',
  src: banquet2,
},
{
  name: 'Pal Poonam',
  text: 'Amazing decoration by Libra Events & Decorators! The designs were creative, elegant, and perfect for our function. Guests loved the photo corners and theme setup. Great work by the entire team.',
  src: banquet3,
},

  ];




  return (
    <>
      <div className="home-video-container">
        <Header />
        <video
          className="background-video"
          src="/videos/libra 4k.mp4"
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="video-dark-overlay"></div>

        <div className="home-content fade-in">
  <h1>Welcome to Libra Events & Decorator</h1>
  <p>Top Wedding, Birthday & Corporate Event Planning Expert</p>
</div>


        {/* Decorative flower line */}
        <div className="flower-divider">
          <div className="vertical-line" />
          <img src={flower} alt="flower" className="flower-icon" />
        </div>

        <Contactbar />
      </div>

      <div className="why-horizontal-row">
  <div className="why-text">
  <h4 class="golden-heading">We are <strong>Libra</strong> Events</h4>
    <h2><strong>Why</strong> Choose Us?</h2>
<p>
  Libra Events & Decorators is among the best wedding and event planners in Vadodara, offering luxury wedding decor, corporate events, and themed parties. From elegant decorations to flawless execution, we make every celebration unforgettable.</p>
    <a href='/AboutUs'><button className="about-btn">About Libra Events</button></a>
  </div>

  <div className="why-cards">
    {/* Repeat or map your 6 cards here */}
    <div className="why-card">🎉 <h3>Creative Ideas</h3><p>We turn dreams into reality.</p></div>
    <div className="why-card">💡 <h3>Innovative Planning</h3><p>Custom experiences.</p></div>
    <div className="why-card">📍 <h3>Perfect Locations</h3><p>Magical venues.</p></div>
    <div className="why-card">👥 <h3>Team Support</h3><p>With you always.</p></div>
    <div className="why-card">🎊 <h3>Flawless Execution</h3><p>Every detail perfect.</p></div>
    <div className="why-card">🌟 <h3>Client Satisfaction</h3><p>Unforgettable memories.</p></div>
  </div>
</div>



      {/* ✅ Moved OUTSIDE home-video-container */}
      <div className="activities-section">
      <h2
        ref={titleRef}
        className={`activities-title ${isVisible ? 'animate' : ''}`}
      >
        Our Activities
      </h2><br></br>
  <div className="activities-carousel">
    <div className="carousel-track">
      {[...Array(2)].flatMap(() => (
        <>
          <div className="video-card">
            <img src={wedding1} alt="Activity 1" className="activity-thumbnail" />
             <div className="activity-overlay">Fantasy Entry</div>
            {/* <div className="play-button">&#9658;</div> */}
          </div>
          <div className="video-card">
            <img src={wedding2} alt="Activity 2" className="activity-thumbnail" />
             <div className="activity-overlay">Haldi</div>
            {/* <div className="play-button">&#9658;</div> */}
          </div>
          <div className="video-card">
            <img src={wedding3} alt="Activity 3" className="activity-thumbnail" />
             <div className="activity-overlay">Sangeet</div>
            {/* <div className="play-button">&#9658;</div> */}
          </div>
          <div className="video-card">
            <img src={wedding4} alt="Activity 4" className="activity-thumbnail" />
             <div className="activity-overlay">Reception</div>
            {/* <div className="play-button">&#9658;</div> */}
          </div>
          <div className="video-card">
            <img src={wedding5} alt="Activity 5" className="activity-thumbnail" />
             <div className="activity-overlay">Food</div>
            {/* <div className="play-button">&#9658;</div> */}
          </div>
          <div className="video-card">
            <img src={wedding6} alt="Activity 6" className="activity-thumbnail" />
             <div className="activity-overlay">Wedding</div>
            {/* <div className="play-button">&#9658;</div> */}
          </div>
        </>
      ))}
    </div>
  </div>
</div>

<div className="banquet-section">
<h2
  ref={titleRef}
  className={`activities-title ${isVisible ? 'animate-banquet' : ''}`}
>
  Banquets
</h2>

<div className="banquet-underline"></div>  {/* Underline element */}
<br />


  <div className="banquet-grid">
    {loopImages.slice(0, 3).map((img, index) => (
      <div className="banquet-slide" key={index}>
        <img src={img.src} alt={`Banquet ${index + 1}`} />
        <div className="banquet-overlay">{img.name}</div>
      </div>
    ))}
  </div>
</div>



<div className="cta-section">
  <h2 className="cta-title">
    Are You Ready To Make <strong>Your Own Special Events?</strong>
  </h2>
  <p className="cta-subtitle">
    “Get started now, Team <strong>Libra</strong> events is here to assist you.”
  </p>
</div>


{/* ✅ Testimonial Section with scroll button */}
<div className="testimonial-section">
  <div className="testimonial-heading">
    <h2
      ref={titleRef}
      className={`activities-title ${isVisible ? 'animate' : ''}`}
    >
      Our Clients Say
    </h2>
  </div>

  <div className="testimonial-main-card">
    <div className="testimonial-slider-wrapper" ref={sliderRef}>
      <div className="testimonial-slider-track">
        {[...testimonials, ...testimonials].map((item, index) => (
          <div
            className="testimonial-card"
            key={index}
            style={{
              backgroundImage: `url(${item.src})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              position: 'relative',
              color: 'white', // to ensure text is visible
              borderRadius: '8px',
              overflow: 'hidden',
              minWidth: '300px',
              marginRight: '16px',
            }}
          >
            {/* Transparent overlay */}
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)', // black with 50% transparency
                zIndex: 1,
              }}
            ></div>

            {/* Content sits above overlay */}
            <div
              className="testimonial-content"
              style={{
                position: 'relative',
                zIndex: 2,
                padding: '20px',
              }}
            >
              <h3>{item.name}</h3>
              <p>{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>

    {/* ⬅ Back Button */}
    <button className="prev-btn" onClick={scrollPrev}>‹</button>

    {/* ➡ Next Button */}
    <button className="next-btn" onClick={scrollNext}>›</button>
  </div>
</div>

<div className="banquet-full-width-section">
  <div className="banquet-intro-content">
    <h2 className="banquet-heading">Redefine Your Celebrations</h2>

    <p className="banquet-para">Welcome to Libra Events & Decorators – Where Every Celebration Shines</p>

    <p className="banquet-para">Libra Events & Decorators is Vadodara’s trusted name in event planning and decoration, offering luxurious yet affordable experiences for every occasion. From elegant weddings and vibrant parties to professional corporate events, we specialize in creating unforgettable memories that reflect your unique style and personality.</p>

    <p className="banquet-para">Our team transforms every venue into a masterpiece with creative décor, attention to detail, and flawless execution. Whether you desire royal-themed interiors, minimal elegance, or a personalized celebration concept, Libra brings your vision to life with professionalism and perfection.</p>
  </div>
</div>


<div className="map-area">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.1513113692577!2d73.1877681!3d22.272257399999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395fc572a56acfcd%3A0x27bab60c571357df!2sLibra%20Events%20%26%20Decorators!5e0!3m2!1sen!2sin!4v1755148852772!5m2!1sen!2sin"width="100%"
                height="300"
                allowFullScreen=""
                loading="lazy"
                title="Google Map Location"></iframe>
              </div>
<Footer/>

    </>
  );
}

export default Home;
